export default "__VITE_ASSET__48ebc9f3__"